'use client';

import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';

interface BackButtonProps {
  onClick: () => void;
  label?: string;
}

const BackButton = ({
  onClick,
  label = 'Back to insights list',
}: BackButtonProps) => (
  <button
    onClick={onClick}
    className="flex items-center gap-2 text-sm font-semibold text-sky-600 hover:text-sky-700 cursor-pointer transition-colors"
    aria-label={label}
    data-testid="profile-drawer-config-v2-back"
  >
    <Icon icon={faChevronLeft} className="text-sm" aria-hidden="true" />
    <span>{label}</span>
  </button>
);

export default BackButton;
